<template>
  <VisionSidebar
    :visible="visible"
    :max-width="710"
    :title="sidebarData.sidebarPage.title"
    :heading-tag="sidebarData.sidebarPage.titleTag"
    @close="close"
  >
    <div
      v-if="status === 'success'"
      :class="bem('body')"
    >
      <DatoStructuredText
        v-if="hasStructuredTextBodyContent"
        :content="sidebarData.sidebarPage.structuredTextBody"
      />
    </div>
  </VisionSidebar>
</template>

<script setup>
import sidebarGql from '@/gql/sidebar.gql'
import { isEmptyDocument } from 'datocms-structured-text-utils'

const { $sentry } = useNuxtApp()
const sidebarStore = useSidebarStore()
const pageStore = usePageStore()

const bem = useBEM('DynamicSidebar')

const props = defineProps({
  slug: {
    type: String,
    default: '',
    required: true,
  },
  visible: {
    type: Boolean,
    default: false,
    required: false,
  },
})

if (props.visible) pageStore.toggleBlockBodyScroll(true)

watch(() => props.visible, (visible) => {
  pageStore.toggleBlockBodyScroll(visible)
})

const {
  data: sidebarData,
  error,
  status
} = await useDatoQuery({
  query: sidebarGql(props.slug),
})

if (error.value) {
  $sentry.captureException(error)
}

function close() {
  pageStore.toggleBlockBodyScroll(false)
  sidebarStore.setActiveSidebar('')
}

const hasStructuredTextBodyContent = computed(() => {
  if (!sidebarData.value) return false

  return !isEmptyDocument(sidebarData.value.sidebarPage.structuredTextBody)
})
</script>

<style lang="postcss" scoped>
.DynamicSidebar__body {
  @apply px-5 pt-5;
}
</style>
